import AjaxForm from "./ajax-forms";

export default function initAfterReplace(element) {
    (new AjaxForm()).initAll(element);
}
